import React from "react";

//import { BiPlayCircle } from "react-icons/bi";
import { useSiteData } from "../context/SiteDataContext";
import defaultData from "../data/hero.json";

const Herov2New = ({ isBg }) => {
  const { data, loading } = useSiteData();
  const herov2New = data?.herov2New || defaultData.herov2New;

  if (loading) return null;

  return (
    <section
      id="hero-new"
      className={`hero hero__padding overflow-hidden position-relative ${isBg === "yes" ? "bg-one" : ""
        }`}
    >
      <div className="circle x1"></div>
      <div className="circle x2"></div>
      <div className="circle x3"></div>
      <div className="circle x4"></div>
      <div className="circle x5"></div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-5 offset-lg-1 text-center">
            <div className="hero__images3 position-relative d-inline-block">
              <img
                width="400"
                className="img-fluid"
                src={herov2New.image}
                alt=""
              />
              <div
                className="position-absolute"
                style={{
                  top: "-5px",
                  left: "-5px",
                  width: "100px",
                  height: "100px",
                  overflow: "hidden",
                  zIndex: 10
                }}
              >
                <div
                  style={{
                    backgroundColor: "#e74c3c",
                    color: "white",
                    textAlign: "center",
                    lineHeight: "34px",
                    width: "150px",
                    fontSize: "12px",
                    fontWeight: "900",
                    textTransform: "uppercase",
                    transform: "rotate(-45deg)",
                    position: "absolute",
                    top: "20px",
                    left: "-40px",
                    boxShadow: "0 5px 10px rgba(0,0,0,0.2)",
                    letterSpacing: "2px"
                  }}
                >
                  Nouveau
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-7 col-lg-6 m-0px-b md-m-40px-b">
            <div className="hero__content position-relative">
              <h1 className="display-4 mb-4 text-capitalize">{herov2New.title}</h1>
              <div
                className="text-muted mb-5 fs-5"
                dangerouslySetInnerHTML={{ __html: herov2New.description }}
              />
              <div>
                <a
                  href={herov2New.buyLink || "https://amzn.eu/d/i0oyx0W"}
                  target="_blank"
                  rel="noreferrer"
                  className="smooth button button__primary me-3"
                >
                  <span>{herov2New.buyBtn}</span>
                </a>
                {/* <a
                  href="https://youtu.be/dkxiTpwm0hs"
                  className="glightbox3 btn__secondary"
                >
                  <BiPlayCircle /> {herov2New.aboutBtn}
                </a> */}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Herov2New;

